function createUniqueArray<T>(array: T[]): T[] {
  return Array.from(new Set(array).values()); // ensure result is array not Iterator
}

export default createUniqueArray;
